import findIndex from 'lodash/findIndex'

export default function findPreviousKey(key: string, itemKeys: string[]) {
  const index = findIndex(itemKeys, (itemKey) => itemKey === key)
  if (index === 0 || index === -1) {
    return null
  }
  return itemKeys[index - 1]
}
